import React, {useRef, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import ComplianceBanner from '../../Molecules/ComplianceBanner';
import { useComplianceCookie } from '../../../utilities/useComplianceCookie';

let bannerHeight = 0;

const ComplianceController = ({
    includeBanner = true,
    bannerMessage = '',
    isGlobalNav = false,
    onBannerHeightChange = () => null
}) =>
{
    const { qlCompliance, setComplianceCookie } = useComplianceCookie();
    const [suppressBanner, setSuppressBanner] = useState(true);

    const bannerRef = useRef();
    const resizeObserver = useRef();

    const handleResize = () =>
    {
        if ( !bannerRef?.current ) 
        {
            onBannerHeightChange(0)
        };
        const observedBannerHeight = bannerRef.current?.scrollHeight ?? 0;
        if ( observedBannerHeight !== bannerHeight )
        {
            bannerHeight = observedBannerHeight;
            onBannerHeightChange( bannerHeight );
        }
    }

    useEffect( () =>
    {
        let shouldSuppress = suppressBanner; 
        if ( !includeBanner )
        {
            shouldSuppress = true;
        }
        else
            if ( !qlCompliance )
            {
                shouldSuppress = false;
            }
            else
            {
                shouldSuppress = !includeBanner || qlCompliance?.isClosed;
            }
        if ( shouldSuppress !== suppressBanner ) 
        {
            setSuppressBanner( shouldSuppress );
        }
        if ( shouldSuppress ) return () => null;
        if ( !window?.ResizeObserver ) return () => null;
        resizeObserver.current = new window.ResizeObserver(
            handleResize
        );
        resizeObserver.current.observe( document.body );

        return () => resizeObserver.current?.disconnect(); 
    }, [])

    const handleBannerClose = () =>
    {
        setComplianceCookie();
        setSuppressBanner(true);
        onBannerHeightChange(0);
    }

    const RenderedBanner = <ComplianceBanner 
        message={ bannerMessage }
        closeAlert={ handleBannerClose } 
        ref={bannerRef}
        isGlobalNav={isGlobalNav}
        key="ComplianceBanner"
    />;

    return (!suppressBanner) ? RenderedBanner : null;
    
}

ComplianceController.propTypes = {
    /** show/hide the compliance banner if appropriate; defaults to true */
    includeBanner: PropTypes.bool,
    /** text content of banner */
    bannerMessage: PropTypes.string,
    /** flag to determine if the global nav is present */   
    isGlobalNav: PropTypes.bool,
    /** callback when height of banner changes */
    onBannerHeightChange: PropTypes.func
}

export default ComplianceController;